<template>
  <div class="slider-container" @click.stop="">
    <!-- <div class="labels">
      <span>{{ searchMin }} 이상</span>
      <span>{{ searchMax }} 이하</span>
    </div> -->

    <div class="slider-wrapper">
      <div class="slider-track">
        <div
          class="slider-range"
          :style="{ left: rangeLeft + '%', width: rangeWidth + '%' }"
        ></div>

        <!-- 눈금과 숫자 표시 -->
        <div class="ticks">
          <div
            v-for="tick in ticks"
            :key="tick"
            class="tick"
            :style="{ left: ((tick - min) / (max - min)) * 100 + '%' }"
          >
            <span class="tick-line"></span>
            <span class="tick-label">{{ tick }}</span>
          </div>
        </div>
      </div>

      <!-- 최소값 핸들 -->
      <input
        type="range"
        id="minHandle"
        :min="min"
        :max="max"
        :step="step"
        v-model="searchMin"
        @input="handleInput(0)"
        @mousedown="bringToFront('min')"
        :class="{ 'on-top': topHandle === 'min' }"
      />

      <!-- 최대값 핸들 -->
      <input
        type="range"
        id="maxHandle"
        :min="min"
        :max="max"
        :step="step"
        v-model="searchMax"
        @input="handleInput(1)"
        @mousedown="bringToFront('max')"
        :class="{ 'on-top': topHandle === 'max' }"
      />
    </div>

    <div class="selected-range">
      선택된 범위: {{ searchMin }} ~ {{ searchMax }}
    </div>
  </div>
</template>

<script setup>
import { searchMax, searchMin } from '@/utils/SearchDevice';
import { ref, computed } from 'vue';

// eslint-disable-next-line no-unused-vars, no-undef
const props = defineProps({
  min: Number,
  max: Number,
  tickInterval: Number,
});

const step = 1;
const topHandle = ref('max');

// 눈금 배열 생성
const ticks = computed(() => {
  const tickArray = [];
  for (let i = props.min; i <= props.max; i += props.tickInterval) {
    tickArray.push(i);
  }
  return tickArray;
});

const rangeLeft = computed(() => ((searchMin.value - props.min) / (props.max - props.min)) * 100);
const rangeWidth = computed(() => ((searchMax.value - searchMin.value) / (props.max - props.min)) * 100);

// 핸들 범위 제한
const handleInput = (index) => {
  const minValue = parseFloat(searchMin.value);
  const maxValue = parseFloat(searchMax.value);

  if (index === 0 && Math.abs(minValue - maxValue) < 0.001) {
    searchMin.value = maxValue;
  }
  if (index === 1 && Math.abs(maxValue - minValue) < 0.001) {
    searchMax.value = minValue;
  }
};

const bringToFront = (handle) => {
  topHandle.value = handle;
};
</script>

<style scoped>
.slider-container {
  width: 100%;
  margin: 50px auto;
  text-align: center;
  margin-top: -20px;
  margin-bottom: -10px;
}

.labels {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 14px;
}

.slider-wrapper {
  position: relative;
  width: 100%;
  height: 70px;
}

.slider-track {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 8px;
  background: #ddd;
  border-radius: 4px;
  transform: translateY(-50%);
  z-index: 1;
}

.slider-range {
  position: absolute;
  height: 100%;
  background: #4287f5;
  border-radius: 4px;
  z-index: 2;
}

/* 눈금 및 숫자 */
.ticks {
  width: 100%;
  height: 30px;
  pointer-events: none;
}

.tick {
  position: absolute;
}

.tick-line {
  display: block;
  width: 1px;
  height: 12px;
  background: #929292; /* 눈금 색상 */
  margin-bottom: 3px;
}

.tick-label {
  font-size: 12px; /* 숫자 크기 */
  color: #444;     /* 숫자 색상 */
}

/* 슬라이더 핸들 */
input[type='range'] {
  width: 100%;
  position: absolute;
  background: transparent;
  pointer-events: none; /* thumb 외에는 클릭 방지 */
  appearance: none;
  border: none;
  z-index: 3;
  padding: 0;
  margin: 0;
}

input[type='range'].on-top {
  z-index: 4;
}

input[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  background: #4287f5;
  border: 2px solid white;
  border-radius: 50%;
  cursor: pointer;
  pointer-events: all;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
}

input[type='range']::-moz-range-thumb {
  width: 20px;
  height: 20px;
  background: #4287f5;
  border: 2px solid white;
  border-radius: 50%;
  cursor: pointer;
  pointer-events: all;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
}

.selected-range {
  margin-top: -5px;
  font-weight: bold;
}
</style>
